import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiUrl from '../../environment/Api';
import axios from 'axios';
import { toast } from 'react-toastify';

function Job() {
  const [activeStep, setActiveStep] = useState(0);
  const [experienceLevel, setExperienceLevel] = useState("");
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState([]);




  const [addData, setAddData] = useState({

    name: '',
    dateofbirth: '',
    contact_number: '',
    email_address: '',
    position: '',
    select_source: '',
    current_address: '',
    permenant_address: '',
    blood_group: '',
    guardian_name: '',
    guardian_phone_number: '',
    higher_qualification: '',
    university: '',
    additional_certification: '',
    field_of_study: '',
    year_of_gradution: '',
    select_experience_year: '',
    techical_skills: '',
    language: '',
    relevant_of_skills: '',
    // organization: '',
    // date_of_joining: '',
    // date_of_relieving: '',
    // designation: '',
    // take_home: '',
    // expected_salary: '',


    organization_one: '',
    date_of_joining_one: '',
    date_of_relieving_one: '',
    designation_one: '',
    take_home_one: '',
    expected_salary_one: '',
    experience_letter_one: '',



    organization_two: '',
    date_of_joining_two: '',
    date_of_relieving_two: '',
    designation_two: '',
    take_home_two: '',
    expected_salary_two: '',
    experience_letter_two: '',




    reference_name_one: '',
    reference_position_one: '',
    reference_phonenumber_one: '',
    reference_email_one: '',
    reference_additional_one: '',

    reference_name_two: '',
    reference_position_two: '',
    reference_phonenumber_two: '',
    reference_email_two: '',
    reference_additional_two: '',


  });


  // const handleSubmit = () => {
  //   navigate("/jobMemberinfo");
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();



    try {

      const formData = {



        name: addData.name,
        dateofbirth: addData.dateofbirth,
        contact_number: addData.contact_number,
        email_address: addData.email_address,
        position: addData.position,
        select_source: addData.select_source,
        current_address: addData.current_address,
        permenant_address: addData.permenant_address,
        blood_group: addData.blood_group,
        guardian_name: addData.guardian_name,
        guardian_phone_number: addData.guardian_phone_number,
        higher_qualification: addData.higher_qualification,
        university: addData.university,
        additional_certification: addData.additional_certification,
        field_of_study: addData.field_of_study,
        year_of_gradution: addData.year_of_gradution,
        select_experience_year: addData.select_experience_year,
        techical_skills: addData.techical_skills,
        language: addData.language,
        relevant_of_skills: addData.relevant_of_skills,
        // organization: addData.organization,
        // date_of_joining: addData.date_of_joining,
        // date_of_relieving: addData.date_of_relieving,
        // designation: addData.designation,
        // take_home: addData.take_home,
        // expected_salary: addData.expected_salary,


        organization_one: addData.organization_one,
        date_of_joining_one: addData.date_of_joining_one,
        date_of_relieving_one: addData.date_of_relieving_one,
        designation_one: addData.designation_one,
        take_home_one: addData.take_home_one,
        expected_salary_one: addData.expected_salary_one,
        experience_letter_one: addData.experience_letter_one,





        organization_two: addData.organization_two,
        date_of_joining_two: addData.date_of_joining_two,
        date_of_relieving_two: addData.date_of_relieving_two,
        designation_two: addData.designation_two,
        take_home_two: addData.take_home_two,
        expected_salary_two: addData.expected_salary_two,
        experience_letter_two: addData.experience_letter_two,




        reference_name_one: addData.reference_name_one,
        reference_position_one: addData.reference_position_one,
        reference_position_one: addData.reference_position_one,
        reference_email_one: addData.reference_email_one,
        reference_additional_one: addData.reference_additional_one,

        reference_name_two: addData.reference_name_two,
        reference_position_two: addData.reference_position_two,
        reference_phonenumber_two: addData.reference_phonenumber_two,
        reference_email_two: addData.reference_email_two,
        reference_additional_two: addData.reference_additional_two,



      }
      const response = await axios.post(apiUrl + "/jobapplication", formData);
      navigate("/jobMemberinfo");
      console.log("Updated the job application:", response);

      toast.success("added successfully!");
      setAddData({

        name: '',
        dateofbirth: '',
        contact_number: '',
        email_address: '',
        position: '',
        select_source: '',
        current_address: '',
        permenant_address: '',
        blood_group: '',
        guardian_name: '',
        guardian_phone_number: '',
        higher_qualification: '',
        university: '',
        additional_certification: '',
        field_of_study: '',
        year_of_gradution: '',
        select_experience_year: '',
        techical_skills: '',
        language: '',
        relevant_of_skills: '',
        // organization: '',
        // date_of_joining: '',
        // date_of_relieving: '',
        // designation: '',
        // take_home: '',
        // expected_salary: '',






        organization_one: '',
        date_of_joining_one: '',
        date_of_relieving_one: '',
        designation_one: '',
        take_home_one: '',
        expected_salary_one: '',
        experience_letter_one: '',
    
    
    
        organization_two: '',
        date_of_joining_two: '',
        date_of_relieving_two: '',
        designation_two: '',
        take_home_two: '',
        expected_salary_two: '',
        experience_letter_two: '',
    


        reference_name_one: '',
        reference_position_one: '',
        reference_phonenumber_one: '',
        reference_email_one: '',
        reference_additional_one: '',

        reference_name_two: '',
        reference_position_two: '',
        reference_phonenumber_two: '',
        reference_email_two: '',
        reference_additional_two: '',

      });

    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);




  const handleNext = () => {
    if (activeStep === 1 && experienceLevel === "Fresher") {
      setActiveStep(3);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    navigate("/Jobportal");
  };

  const handleExperienceChange = (e) => {
    setExperienceLevel(e.target.value);
  };


















  return (
    <>
      <div className="container" style={{ marginTop: "-50px" }}>
        <h3 className="">Job Application</h3>
        {activeStep === 0 && (
          <div className="card p-2">
            <h5 className="text-center">Personal Details</h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    value={addData.name}
                    onChange={(e) =>
                      setAddData({ ...addData, name: e.target.value })
                    }

                    type="text"
                    placeholder=""
                    required
                  />
                  <label className="">Full Name</label>
                </div>





                <div className="floating-label">
                  <input
                    className="form-control"
                    type="date"
                    placeholder=""
                    value={addData.dateofbirth}
                    onChange={(e) =>
                      setAddData({ ...addData, dateofbirth: e.target.value })
                    }

                    required
                  />
                  <label className="">Date of Birth</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.contact_number}
                    onChange={(e) =>
                      setAddData({ ...addData, contact_number: e.target.value })
                    }
                    required

                  />
                  <label className="">Contact Number</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="email"
                    placeholder=""
                    value={addData.email_address}
                    onChange={(e) =>
                      setAddData({ ...addData, email_address: e.target.value })
                    }
                    required
                  />
                  <label className="">Email Address</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.position}
                    onChange={(e) =>
                      setAddData({ ...addData, position: e.target.value })
                    }
                    required
                  />
                  <label className="">Position</label>
                </div>
                {/* <div className="floating-label">
                  <select className="form-control" required>
                    <option value="source1"> Select Source</option>
                    <option value="source1">Referral</option>
                    <option value="source2">Job Portal</option>
                    <option value="source3">Campus Recruitment</option>
                  </select>
                </div> */}
                <div className="floating-label">
                  <select
                    className="form-control"
                    value={addData.select_source}  // Bind the select to the state
                    onChange={(e) =>
                      setAddData({ ...addData, select_source: e.target.value })  // Update state when value changes
                    }
                    required
                  >
                    <option value="">Select Source</option>
                    <option value="Referral">Referral</option>
                    <option value="Job Portal">Job Portal</option>
                    <option value="Campus Recruitment">Campus Recruitment</option>
                  </select>
                </div>

              </div>
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.current_address}
                    onChange={(e) =>
                      setAddData({ ...addData, current_address: e.target.value })
                    }
                    required
                  />
                  <label className="">Current Address</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.permanent_address}
                    onChange={(e) =>
                      setAddData({ ...addData, permanent_address: e.target.value })
                    }
                    required
                  />
                  <label className="">Permanent Address</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.blood_group}
                    onChange={(e) =>
                      setAddData({ ...addData, blood_group: e.target.value })
                    }
                    required
                  />
                  <label className="">Blood Group</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.guardian_name}
                    onChange={(e) =>
                      setAddData({ ...addData, guardian_name: e.target.value })
                    }

                    required
                  />
                  <label className="">Guardian Name</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.guardian_phone_number}
                    onChange={(e) =>
                      setAddData({ ...addData, guardian_phone_number: e.target.value })
                    }

                    required
                  />
                  <label className="">Guardian Phone Number</label>
                </div>

                <div className="text-center p-2">
                  <button
                    className="btn btn-secondary mx-2"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-danger" onClick={handleNext}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeStep === 1 && (
          <div className="card p-3">
            <h5 className="text-center">Education Details</h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.higher_qualification}
                    onChange={(e) =>
                      setAddData({ ...addData, higher_qualification: e.target.value })
                    }
                    required
                  />
                  <label className="">Highest Qualification</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.university}
                    onChange={(e) =>
                      setAddData({ ...addData, university: e.target.value })
                    }
                    required
                  />
                  <label className="">University / Institution Name</label>
                </div>

                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.additional_certification}
                    onChange={(e) =>
                      setAddData({ ...addData, additional_certification: e.target.value })
                    }

                    required
                  />
                  <label className="">Additional Certifications</label>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.field_of_study}
                    onChange={(e) =>
                      setAddData({ ...addData, field_of_study: e.target.value })
                    }


                    required
                  />
                  <label className="">Field of Study</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.year_of_gradution}
                    onChange={(e) =>
                      setAddData({ ...addData, year_of_gradution: e.target.value })
                    }

                    required
                  />
                  <label className="">Year of Graduation</label>
                </div>

                <div className="floating-label">
                  <select
                    className="form-control"
                    onChange={handleExperienceChange}
                    required
                  >
                    <option value="">Select Experience Year</option>
                    <option value="Fresher">Fresher</option>
                    <option value="Experience">Experience</option>
                  </select>
                </div>

                {/* <div className="floating-label">
                  <select
                    className="form-control"
                    value={addData.select_experience_year} // Bind the select to the state
                    onChange={(e) =>
                      setAddData({ ...addData, select_experience_year: e.target.value }) // Update state when value changes
                    }
                    required
                  >
                    <option value="">Select Experience Year</option>
                    <option value="Fresher">Fresher</option>
                    <option value="Experience">Experience</option>
                  </select>
                </div> */}

              </div>
              <div className="text-center p-2">
                <button className="btn btn-secondary mx-2" onClick={handleBack}>
                  Back
                </button>
                <button className="btn btn-danger" onClick={handleNext}>
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {activeStep === 2 && experienceLevel === "Experience" && (
          <div className="card p-3">

            <h5 className="text-center">Experience 1</h5>
            <div className="row">
              {/* Professional Details Fields */}
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.organization_one}
                    onChange={(e) =>
                      setAddData({ ...addData, organization_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Organization</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="date"
                    placeholder=""
                    value={addData.date_of_joining_one}
                    onChange={(e) =>
                      setAddData({ ...addData, date_of_joining_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Date of Joining</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="date"
                    placeholder=""
                    value={addData.date_of_relieving_one}
                    onChange={(e) =>
                      setAddData({ ...addData, date_of_relieving_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Date of Relieving</label>
                </div>


                <div className="floating-label">
                  <input
                    className="form-control"
                    type="file"
                    placeholder=""
                    value={addData.experience_letter_one}
                    onChange={(e) =>
                      setAddData({ ...addData, experience_letter_one: e.target.value })
                    }
                    required
                  />
                  <label className="">experience_letter_one</label>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.designation}
                    onChange={(e) =>
                      setAddData({ ...addData, designation: e.target.value })
                    }
                    required
                  />
                  <label className="">Designation</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.take_home}
                    onChange={(e) =>
                      setAddData({ ...addData, take_home: e.target.value })
                    }
                    required
                  />
                  <label className="">Take Home</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.expected_salary}
                    onChange={(e) =>
                      setAddData({ ...addData, expected_salary: e.target.value })
                    }
                    required
                  />
                  <label className="">Expected Salary</label>
                </div>
              </div>


              <div className="row">
                <h5 className="text-center">Experience 2</h5>

                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.organization_two}
                      onChange={(e) =>
                        setAddData({ ...addData, organization_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Organization</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={addData.date_of_joining_two}
                      onChange={(e) =>
                        setAddData({ ...addData, date_of_joining_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Date of Joining</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={addData.date_of_relieving_two}
                      onChange={(e) =>
                        setAddData({ ...addData, date_of_relieving_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Date of Relieving</label>
                  </div>




                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="file"
                      placeholder=""
                      value={addData.experience_letter_two}
                      onChange={(e) =>
                        setAddData({ ...addData, experience_letter_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Expected letter</label>
                  </div>
                </div>


                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.designation_two}
                      onChange={(e) =>
                        setAddData({ ...addData, designation_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Designation</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.take_home_two}
                      onChange={(e) =>
                        setAddData({ ...addData, take_home_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Take Home</label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.expected_salary_two}
                      onChange={(e) =>
                        setAddData({ ...addData, expected_salary_two: e.target.value })
                      }
                      required
                    />
                    <label className="">Expected Salary</label>
                  </div>
              
                </div>




              </div>


              <div className="text-center p-2">
                <button className="btn btn-secondary mx-2" onClick={handleBack}>
                  Back
                </button>
                <button className="btn btn-danger" onClick={handleNext}>
                  Next
                </button>
              </div>
            </div>
          </div>


        )}

        {activeStep === 3 && (
          <div className="card p-3">
            <h5 className="text-center">Skills and Competition</h5>
            <div className="row">
              <div className="col-lg-6">
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.techical_skills}
                    onChange={(e) =>
                      setAddData({ ...addData, techical_skills: e.target.value })
                    }
                    required
                  />
                  <label className="">Technical Skills</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.language}
                    onChange={(e) =>
                      setAddData({ ...addData, language: e.target.value })
                    }
                    required
                  />
                  <label className="">Languages</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.relevant_of_skills}
                    onChange={(e) =>
                      setAddData({ ...addData, relevant_of_skills: e.target.value })
                    }
                    required
                  />
                  <label className="">Relevant Soft Skills</label>
                </div>
              </div>

              <div className="text-center p-2">
                <button className="btn btn-secondary mx-2" onClick={handleBack}>
                  Back
                </button>
                <button className="btn btn-danger" onClick={handleNext}>
                  Next
                </button>
              </div>
            </div>
          </div>
        )}

        {activeStep === 4 && (
          <div className="card p-3">
            <h5 className="text-center">References</h5>
            <div className="row">
              <div className="col-lg-6">
                <h3 className="">Reference 1</h3>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_name_one}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_name_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Name</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_position_one}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_position_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Position</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_phonenumber_one}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_phonenumber_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Contact Number</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_email_one}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_email_one: e.target.value })
                    }
                    required
                  />
                  <label className="">Email Address</label>
                </div>
              </div>

              <div className="col-lg-6">
                <h3 className="">Reference 2</h3>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_name_two}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_name_two: e.target.value })
                    }
                    required
                  />
                  <label className="">Name</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_position_two}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_position_two: e.target.value })
                    }
                    required
                  />
                  <label className="">Position</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="text"
                    placeholder=""
                    value={addData.reference_phonenumber_two}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_phonenumber_two: e.target.value })
                    }
                    required
                  />
                  <label className="">Contact Number</label>
                </div>
                <div className="floating-label">
                  <input
                    className="form-control"
                    type="email"
                    placeholder=""
                    value={addData.reference_email_two}
                    onChange={(e) =>
                      setAddData({ ...addData, reference_email_two: e.target.value })
                    }
                    required
                  />
                  <label className="">Email Address</label>
                </div>
              </div>
            </div>

            <div className="floating-label">
              <textarea
                className="form-control"
                type="text"
                placeholder=""
                value={addData.reference_additional_two}
                onChange={(e) =>
                  setAddData({ ...addData, reference_additional_two: e.target.value })
                }
                required
              />
              <label className="">Additional Information</label>
            </div>

            <div className="text-center p-2">
              <button className="btn btn-secondary mx-2" onClick={handleBack}>
                Back
              </button>
              <button className="btn btn-danger" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Job;
